/* ════════════════════════════════════════════════════
   HATSY THEME — theme.js  v2
   Dynamic Shipping Bar · Refined Qty · Recently Viewed
════════════════════════════════════════════════════ */

const FREE_SHIPPING_THRESHOLD = 7500; // $75.00 in cents

const qs  = (s, c = document) => c.querySelector(s);
const qsa = (s, c = document) => [...c.querySelectorAll(s)];
const fmt = c => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
function escHtml(s) {
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ════════════════════════════════════════════════════
   RECENTLY VIEWED
════════════════════════════════════════════════════ */
const RV_KEY = 'hatsy_rv';
function getRV() {
  try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; }
}
function saveRV(items) {
  try { localStorage.setItem(RV_KEY, JSON.stringify(items.slice(0, 6))); } catch {}
}
if (window.__hatsy_product) {
  const p = window.__hatsy_product;
  if (p?.id) {
    let rv = getRV().filter(x => x.id !== p.id);
    rv.unshift({ id: p.id, title: p.title, url: p.url, price: p.price,
      image: p.featured_image?.src || p.images?.[0] || '',
      variant: p.variants?.[0]?.id });
    saveRV(rv);
  }
}

/* ════════════════════════════════════════════════════
   OVERLAY
════════════════════════════════════════════════════ */
const overlay = qs('#site-overlay');
let activeDrawer = null;

let savedScrollY = 0;

function showOverlay() {
  overlay?.classList.add('is-visible');
  // Lock body scroll properly on iOS by fixing position
  savedScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.style.top = '-' + savedScrollY + 'px';
  document.body.classList.add('overflow-hidden');
}
function hideOverlay() {
  overlay?.classList.remove('is-visible');
  document.body.classList.remove('overflow-hidden');
  document.body.style.top = '';
  // Restore scroll position
  window.scrollTo(0, savedScrollY);
  if (activeDrawer === 'menu') closeMenu();
  if (activeDrawer === 'cart') closeCart();
  activeDrawer = null;
}
overlay?.addEventListener('click', hideOverlay);
document.addEventListener('keydown', e => { if (e.key === 'Escape') hideOverlay(); });

/* ════════════════════════════════════════════════════
   MENU DRAWER
════════════════════════════════════════════════════ */
const menuDrawer = qs('#menu-drawer');

function openMenu() {
  if (activeDrawer === 'cart') closeCart();
  menuDrawer?.classList.add('is-open');
  activeDrawer = 'menu';
  showOverlay();
  qsa('[data-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
}
function closeMenu() {
  menuDrawer?.classList.remove('is-open');
  if (activeDrawer === 'menu') activeDrawer = null;
  qsa('[data-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
}
qsa('[data-menu-open]').forEach(b => b.addEventListener('click', openMenu));
qsa('[data-menu-close]').forEach(b => b.addEventListener('click', hideOverlay));

/* Accordion */
qsa('.nav-drawer__has-sub').forEach(item => {
  qs('.nav-drawer__item-toggle', item)?.addEventListener('click', () => {
    const open = item.classList.contains('is-expanded');
    qsa('.nav-drawer__has-sub.is-expanded').forEach(el => el.classList.remove('is-expanded'));
    if (!open) item.classList.add('is-expanded');
  });
});

/* ════════════════════════════════════════════════════
   CART DRAWER
════════════════════════════════════════════════════ */
const cartDrawer   = qs('#cart-drawer');
const cartItemsEl  = qs('#cart-items');
const cartFooterEl = qs('#cart-footer');
const shipMsg      = qs('#shipping-bar-msg');
const shipFill     = qs('#shipping-bar-fill');
let cartState      = null;

function openCart() {
  if (activeDrawer === 'menu') closeMenu();
  cartDrawer?.classList.add('is-open');
  activeDrawer = 'cart';
  showOverlay();
  refreshCart();
}
function closeCart() {
  cartDrawer?.classList.remove('is-open');
  if (activeDrawer === 'cart') activeDrawer = null;
}
qsa('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
qsa('[data-cart-close]').forEach(b => b.addEventListener('click', hideOverlay));

/* ─── DYNAMIC SHIPPING BAR ─── */
function updateShippingBar(totalCents) {
  if (!shipFill || !shipMsg) return;
  const remaining = FREE_SHIPPING_THRESHOLD - totalCents;
  const pct       = Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD) * 100);
  /* Smooth fill */
  shipFill.style.width = pct + '%';
  if (remaining <= 0) {
    shipFill.classList.add('shipping-bar__fill--complete');
    shipMsg.innerHTML = '<span class="shipping-bar__unlocked">&#10003;&nbsp; Free US shipping unlocked!</span>';
  } else {
    shipFill.classList.remove('shipping-bar__fill--complete');
    shipMsg.innerHTML = `Add <strong>${fmt(remaining)}</strong> more for free US shipping`;
  }
}

/* ─── FETCH + RENDER ─── */
async function refreshCart() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    cartState  = cart;
    /* Badges */
    qsa('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('visible', cart.item_count > 0);
    });
    qsa('[data-bag-label]').forEach(el => {
      el.textContent = `Bag\u2009(${cart.item_count})`;
    });
    updateShippingBar(cart.total_price);
    renderCartItems(cart);
    renderCartFooter(cart);
    renderRecentlyViewed(cart);
  } catch (e) { console.error('[Hatsy] cart refresh:', e); }
}

function renderCartItems(cart) {
  if (!cartItemsEl) return;
  if (!cart.items.length) {
    cartItemsEl.innerHTML = `
      <div class="cart-empty">
        <div class="cart-empty__icon">
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none" stroke="var(--stone-dark)" stroke-width="1.2" stroke-linecap="round">
            <path d="M8 13h5l6 22h16l5-17H17"/>
            <circle cx="24" cy="41" r="2.5"/><circle cx="35" cy="41" r="2.5"/>
          </svg>
        </div>
        <p class="cart-empty__title">Your bag is empty</p>
        <p class="cart-empty__sub">Add something silk-lined to get started</p>
        <a href="/collections/all" class="cart-empty__link" data-cart-close>Continue shopping</a>
      </div>`;
    qsa('[data-cart-close]', cartItemsEl).forEach(b => b.addEventListener('click', hideOverlay));
    return;
  }
  cartItemsEl.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item" data-index="${i}">
      <a href="${item.url}" class="cart-item__img">
        ${item.image ? `<img src="${item.image.replace(/(\.(jpg|jpeg|png|webp))/, '_120x$1')}" alt="${escHtml(item.title)}" width="76" height="76" loading="lazy">` : ''}
      </a>
      <div class="cart-item__info">
        <div class="cart-item__vendor">${escHtml(item.vendor)}</div>
        <a href="${item.url}" class="cart-item__title">${escHtml(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${escHtml(item.variant_title)}</div>` : ''}
        <div class="cart-item__bottom">
          <div class="qty-control">
            <button class="qty-control__btn" data-key="${item.key}" data-delta="-1"
                    aria-label="Decrease quantity">&#8722;</button>
            <div class="qty-control__sep"></div>
            <span class="qty-control__val">${item.quantity}</span>
            <div class="qty-control__sep"></div>
            <button class="qty-control__btn" data-key="${item.key}" data-delta="1"
                    aria-label="Increase quantity">+</button>
          </div>
          <span class="cart-item__price">${fmt(item.line_price)}</span>
        </div>
      </div>
      <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">
          <path d="M1 1l9 9M10 1L1 10"/>
        </svg>
      </button>
    </div>`).join('');

  qsa('.qty-control__btn', cartItemsEl).forEach(btn => {
    btn.addEventListener('click', async () => {
      const key   = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta);
      const item  = cartState?.items.find(i => i.key === key);
      if (!item) return;
      const newQty = Math.max(0, item.quantity + delta);
      await changeQty(key, newQty);
    });
  });
  qsa('.cart-item__remove', cartItemsEl).forEach(btn => {
    btn.addEventListener('click', () => changeQty(btn.dataset.key, 0));
  });
}

function renderCartFooter(cart) {
  if (!cartFooterEl) return;
  const qc = document.getElementById('cart-quick-checkout');
  if (!cart.items.length) {
    cartFooterEl.innerHTML = '';
    if (qc) qc.style.display = 'none';
    return;
  }
  const unlocked = cart.total_price >= FREE_SHIPPING_THRESHOLD;
  cartFooterEl.innerHTML = `
    <div class="cart-subtotal">
      <span class="cart-subtotal__label">Subtotal</span>
      <span class="cart-subtotal__value">${fmt(cart.total_price)}</span>
    </div>
    <div class="cart-shipping-unlocked ${unlocked ? 'visible' : ''}">
      <span class="cart-shipping-unlocked__label">Shipping</span>
      <span class="cart-shipping-unlocked__value">Free</span>
    </div>
    <p class="cart-subtotal__note">${unlocked ? 'Free US shipping applied' : 'Shipping calculated at checkout'}</p>
    <a href="/checkout" class="cart-checkout-btn">
      Checkout
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M2.5 6.5h8M7.5 3.5l3 3-3 3"/></svg>
    </a>`;
  if (qc) qc.style.display = 'block';
  if (window.HatsyCartExtras) window.HatsyCartExtras(cart, cartFooterEl);
}

function renderRecentlyViewed(cart) {
  const rvEl = qs('#cart-recently-viewed');
  if (!rvEl) return;
  const cartIds = (cart?.items || []).map(i => i.product_id);
  const rv = getRV().filter(p => !cartIds.includes(p.id)).slice(0, 3);
  if (!rv.length) { rvEl.style.display = 'none'; return; }
  rvEl.style.display = 'block';
  rvEl.innerHTML = `
    <div class="cart-also-like__heading">You May Also Like</div>
    <div class="cart-al__grid">
      ${rv.map(p => `
        <div class="cart-al__item">
          <a href="${p.url}" class="cart-al__img">
            ${p.image ? `<img src="${p.image.replace(/(\.(jpg|jpeg|png|webp))/, '_120x$1')}" alt="${escHtml(p.title)}" loading="lazy">` : `<div style="width:100%;height:100%;background:var(--surface);"></div>`}
          </a>
          <div class="cart-al__info">
            <div class="cart-al__name">${escHtml(p.title)}</div>
            <div class="cart-al__price">${fmt(p.price)}</div>
          </div>
          ${p.variant
            ? `<button class="cart-al__add" data-variant="${p.variant}">+ Add</button>`
            : `<a href="${p.url}" class="cart-al__add">View</a>`}
        </div>`).join('')}
    </div>`;
  qsa('.cart-al__add[data-variant]', rvEl).forEach(btn => {
    btn.addEventListener('click', async () => {
      const orig = btn.textContent;
      btn.textContent = '...'; btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variant, quantity: 1 })
        });
        btn.textContent = '\u2713 Added'; btn.classList.add('added');
        await refreshCart();
      } catch { btn.textContent = orig; btn.disabled = false; }
    });
  });
}

async function changeQty(key, qty) {
  try {
    const res  = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    cartState  = cart;
    qsa('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('visible', cart.item_count > 0);
    });
    qsa('[data-bag-label]').forEach(el => {
      el.textContent = `Bag\u2009(${cart.item_count})`;
    });
    updateShippingBar(cart.total_price);
    renderCartItems(cart);
    renderCartFooter(cart);
    renderRecentlyViewed(cart);
  } catch (e) { console.error('[Hatsy] changeQty:', e); }
}

/* ─── Add-to-cart form intercept ─── */
document.addEventListener('submit', async e => {
  const form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  /* never add a sold-out item (or add twice while another handler is already adding) */
  if (btn && (btn.disabled || /sold\s*out/i.test(btn.textContent))) return;
  const orig = btn?.textContent;
  if (btn) { btn.dataset.busy = '1'; btn.textContent = 'Adding...'; btn.disabled = true; }
  try {
    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    await refreshCart();
    openCart();
  } catch (e) { console.error('[Hatsy] add to cart:', e); }
  finally { if (btn) { btn.textContent = orig; btn.disabled = false; delete btn.dataset.busy; } }
});

/* Init */
refreshCart();

/* ════════════════════════════════════════════════
   PRODUCT PAGE — gallery + variant switching
════════════════════════════════════════════════ */
(function initProductPage() {
  /* Gallery */
  const mainSlides = qsa('.product-gallery__slide');
  const thumbBtns  = qsa('.product-gallery__thumb');

  function setSlide(i) {
    mainSlides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
    thumbBtns.forEach((t, idx)  => t.classList.toggle('is-active', idx === i));
  }
  thumbBtns.forEach((btn, i) => btn.addEventListener('click', () => setSlide(i)));

  /* Variant switching */
  const variants   = window.__hatsy_variants || [];
  const variantId  = qs('#product-variant-id');
  const priceEl    = qs('#product-price');
  const atcBtn     = qs('#product-atc');

  let selectedOptions = [];

  /* Init from Shopify selected variant */
  const currentVariant = variants.find(v => v.id == variantId?.value);
  if (currentVariant) selectedOptions = [...currentVariant.options];

  function fmt2(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/,''); }

  function updateVariant() {
    const match = variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!match || !variantId) return;
    variantId.value = match.id;

    /* Price */
    if (priceEl) {
      let html = '';
      if (match.compare_at_price > match.price) {
        html += `<s style="color:var(--ink-light);margin-right:6px;">${fmt2(match.compare_at_price)}</s>`;
      }
      html += `<span class="product-info__price--current">${fmt2(match.price)}</span>`;
      priceEl.innerHTML = html;
    }

    /* ATC button */
    if (atcBtn) {
      if (match.available) {
        atcBtn.textContent = 'Add to Bag';
        atcBtn.disabled = false;
      } else {
        atcBtn.textContent = 'Sold Out';
        atcBtn.disabled = true;
      }
    }

    /* Swap gallery image if variant has image */
    if (match.featured_image) {
      const targetSrc = match.featured_image.src;
      const idx = mainSlides.findIndex(s => {
        const img = s.querySelector('img');
        return img && img.src.includes(targetSrc.split('.jpg')[0].split('/').pop());
      });
      if (idx >= 0) setSlide(idx);
    }
  }

  /* Option buttons */
  qsa('.product-option__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const optIdx = parseInt(btn.dataset.optionIndex);
      selectedOptions[optIdx] = btn.dataset.value;

      /* Update selected state */
      const group = btn.closest('.product-option__buttons');
      qsa('.product-option__btn', group).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      updateVariant();
    });
  });

  /* Color swatches */
  qsa('.product-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      const optIdx = parseInt(btn.dataset.optionIndex);
      selectedOptions[optIdx] = btn.dataset.value;

      const group = btn.closest('.product-option__swatches');
      qsa('.product-swatch', group).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      /* Update color label */
      const label = qs(`.selected-option-label[data-option-index="${optIdx}"]`);
      if (label) label.textContent = btn.dataset.value;

      updateVariant();
    });
  });

  /* Quantity buttons */
  const qtyInput = qs('#product-qty');
  qs('#qty-minus')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
  });
  qs('#qty-plus')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = Math.min(99, parseInt(qtyInput.value) + 1);
  });
})();

/* ════════════════════════════════════════════════
   PRODUCT CAROUSELS — drag/swipe, arrows, dots
════════════════════════════════════════════════ */
(function initCarousels() {

  function initCarousel(wrapId) {
    const wrap  = document.getElementById(wrapId);
    if (!wrap) return;
    const track = document.getElementById(wrapId + '-track');
    const prevBtn = wrap.querySelector('.carousel-btn--prev') 
                    || (wrap.dataset.prev ? document.getElementById(wrap.dataset.prev) : null);
    const nextBtn = wrap.querySelector('.carousel-btn--next')
                    || (wrap.dataset.next ? document.getElementById(wrap.dataset.next) : null);
    if (!track) return;

    const slides = [...track.querySelectorAll('.carousel-slide')];
    if (!slides.length) return;

    const isMobile = () => window.innerWidth <= 700;
    const perView  = () => isMobile() ? 2 : 4;
    const gap      = 12;

    let current    = 0;
    let startX     = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragDelta  = 0;

    function slideWidth() {
      return slides[0]?.offsetWidth ?? 0;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, maxIndex()));
      const offset = current * (slideWidth() + gap);
      track.style.transform = `translateX(-${offset}px)`;
      updateDots();
      updateButtons();
    }

    function updateButtons() {
      prevBtn?.classList.toggle('is-hidden', current <= 0);
      nextBtn?.classList.toggle('is-hidden', current >= maxIndex());
    }

    // Fraction counter elements
    const trackEl = document.getElementById(wrapId + '-dots');
    let counterCur = null, fillEl = null, totalCount = 0;

    function buildDots() {
      if (!trackEl) return;
      totalCount = maxIndex() + 1;
      const fmt = n => String(n).padStart(2, '0');
      trackEl.innerHTML = `
        <span class="carousel-counter">
          <span class="carousel-counter__current">${fmt(1)}</span>
        </span>
        <div class="carousel-dots-fill-wrap">
          <div class="carousel-dots-fill" style="width:${100/totalCount}%"></div>
        </div>
        <span class="carousel-counter">${fmt(slides.length)}</span>`;
      counterCur = trackEl.querySelector('.carousel-counter__current');
      fillEl      = trackEl.querySelector('.carousel-dots-fill');
    }

    function updateDots() {
      if (!counterCur || !fillEl) return;
      const fmt = n => String(n).padStart(2, '0');
      counterCur.textContent = fmt(current + 1);
      fillEl.style.width = ((current + 1) / totalCount * 100) + '%';
    }

    // Arrow buttons
    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));

    // Touch / mouse drag
    var dragStartY = 0;
    var dragLocked = false;
    function onDragStart(e) {
      isDragging = true;
      dragLocked = false;
      dragStartX = e.touches ? e.touches[0].clientX : e.clientX;
      dragStartY = e.touches ? e.touches[0].clientY : e.clientY;
      dragDelta  = 0;
      track.classList.add('is-dragging');
    }
    function onDragMove(e) {
      if (!isDragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const y = e.touches ? e.touches[0].clientY : e.clientY;
      const dx = x - dragStartX;
      const dy = y - dragStartY;
      // If first move is more vertical than horizontal, cancel carousel drag
      if (!dragLocked) {
        if (Math.abs(dy) > Math.abs(dx)) {
          isDragging = false;
          track.classList.remove('is-dragging');
          goTo(current);
          return;
        }
        dragLocked = true;
      }
      dragDelta = dx;
      const base = current * (slideWidth() + gap);
      track.style.transform = `translateX(${-base + dragDelta}px)`;
    }
    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      const threshold = slideWidth() * 0.25;
      if (dragDelta < -threshold) goTo(current + 1);
      else if (dragDelta > threshold) goTo(current - 1);
      else goTo(current);
    }

    wrap.addEventListener('mousedown',  onDragStart);
    wrap.addEventListener('touchstart', onDragStart, { passive: true });
    window.addEventListener('mousemove',  onDragMove);
    window.addEventListener('touchmove',  onDragMove, { passive: true });
    window.addEventListener('mouseup',   onDragEnd);
    window.addEventListener('touchend',  onDragEnd);

    // Click suppression after drag
    wrap.addEventListener('click', e => {
      if (Math.abs(dragDelta) > 8) e.preventDefault();
    }, true);

    // Init
    buildDots();
    goTo(0);

    // Re-init on resize
    window.addEventListener('resize', () => {
      buildDots();
      goTo(Math.min(current, maxIndex()));
    });
  }

  // Init both carousels
  initCarousel('carousel-trending');
  initCarousel('carousel-bestsellers');
  initCarousel('carousel-collections');

})();

/* ════════════════════════════════════════════════
   QUICK ADD — carousel product cards
════════════════════════════════════════════════ */
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.product-card__quick-add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  if (!variantId || btn.dataset.available === 'false') return;

  // Prevent double-click
  if (btn.disabled) return;
  btn.disabled = true;

  const origHtml = btn.innerHTML;
  btn.classList.add('is-adding');
  btn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="animation:spin .7s linear infinite"><path d="M6 1a5 5 0 0 1 5 5"/></svg> Adding...`;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    btn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M2 6l3 3 5-5"/></svg> Added`;

    // Refresh cart count + open drawer
    await refreshCart();
    openCart();

    // Reset after delay
    setTimeout(() => {
      btn.classList.remove('is-added');
      btn.innerHTML = origHtml;
      btn.disabled = false;
    }, 2200);

  } catch (err) {
    btn.classList.remove('is-adding');
    btn.innerHTML = origHtml;
    btn.disabled = false;
    console.error('[Hatsy] Quick add error:', err);
  }
});

/* ════════════════════════════════════════════════
   HERO — apply mobile height + image position from data attrs
   (Liquid inside <style> tags is forbidden in static sections)
════════════════════════════════════════════════ */
(function applyHeroMobileStyles() {
  function apply() {
    const heroes = document.querySelectorAll('.hero-section');
    const isMobile = window.innerWidth <= 600;
    heroes.forEach(function(hero) {
      if (hero.classList.contains('hero-section--editorial')) { hero.style.height = ''; return; } /* editorial hero sizes itself in CSS */
      // Read config from embedded JSON script block
      const cfgEl = hero.querySelector('.hero-config');
      const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      const navH = parseInt(getComputedStyle(document.documentElement)
                    .getPropertyValue('--nav-h')) || 60;
      if (isMobile) {
        const hMob   = cfg.hMob   || 70;
        const posMob = cfg.pMob   || 25;
        hero.style.height = 'calc(' + hMob + 'vh - ' + navH + 'px)';
        hero.querySelectorAll('.hero-photo').forEach(function(img) {
          img.style.objectPosition = 'center ' + posMob + '%';
        });
      } else {
        const hDesk   = cfg.hDesk   || 93;
        const posDesk = cfg.pDesk   || 30;
        hero.style.height = 'calc(' + hDesk + 'vh - ' + navH + 'px)';
        hero.querySelectorAll('.hero-photo').forEach(function(img) {
          img.style.objectPosition = 'center ' + posDesk + '%';
        });
      }
    });
  }
  apply();
  window.addEventListener('resize', apply);
})();


/* Header arrows handled by initCarousels via data-prev/data-next */



/* ════════════════════════════════════════════════
   WISHLIST SYSTEM — drawer, hearts, nav badge
════════════════════════════════════════════════ */
(function() {
  const WL_KEY = 'hatsy_wishlist';
  const fmt    = p => (p / 100).toFixed(2).replace(/\.00$/, '').replace(/^/, '$');
  const esc    = s => String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));

  /* ── Storage with 48hr expiry ── */
  const TTL = 48 * 60 * 60 * 1000; // 48 hours in ms
  function getWL() {
    try {
      const raw = JSON.parse(localStorage.getItem(WL_KEY) || '{"items":[],"ts":0}');
      // Support both old array format and new {items, ts} format
      if (Array.isArray(raw)) return raw;
      const now = Date.now();
      if (raw.ts && (now - raw.ts) > TTL) {
        localStorage.removeItem(WL_KEY);
        return [];
      }
      return raw.items || [];
    } catch { return []; }
  }
  function saveWL(items) {
    try {
      localStorage.setItem(WL_KEY, JSON.stringify({ items: items, ts: Date.now() }));
    } catch {}
  }
  function isWished(id) { return getWL().some(x => x.id === id); }

  /* ── Notify ── */
  function notify() { window.dispatchEvent(new CustomEvent('hatsy:wishlist-updated')); }

  /* ── Nav badge — updates count like Bag (n) ── */
  function updateBadge() {
    const cnt = document.getElementById('nav-wish-count');
    const n   = getWL().length;
    if (cnt) cnt.textContent = n;
  }

  /* ── Heart button state ── */
  function applyHeart(btn) {
    const id = parseInt(btn.dataset.productId);
    btn.classList.toggle('is-wishlisted', isWished(id));
  }

  function attachHeart(btn) {
    if (btn._wlAttached) return;
    btn._wlAttached = true;
    applyHeart(btn);
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const id      = parseInt(btn.dataset.productId);
      const title   = btn.dataset.productTitle || '';
      const price   = parseInt(btn.dataset.productPrice) || 0;
      const url     = btn.dataset.productUrl || '';
      const image   = btn.dataset.productImage || '';
      const variant = parseInt(btn.dataset.variant) || 0;
      let wl = getWL();
      if (isWished(id)) {
        wl = wl.filter(x => x.id !== id);
      } else {
        wl.unshift({ id, title, price, url, image, variant });
        wl = wl.slice(0, 50);
      }
      saveWL(wl);
      // Update all hearts for this product
      document.querySelectorAll('.js-wish[data-product-id="' + id + '"]').forEach(applyHeart);
      updateBadge();
      notify();
    });
  }

  /* ── Init all hearts now + observe future ones ── */
  function initAllHearts() {
    document.querySelectorAll('.js-wish').forEach(attachHeart);
  }
  initAllHearts();
  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes.forEach(n => {
      if (n.nodeType !== 1) return;
      if (n.matches && n.matches('.js-wish')) attachHeart(n);
      n.querySelectorAll && n.querySelectorAll('.js-wish').forEach(attachHeart);
    }));
  }).observe(document.body, { childList: true, subtree: true });


  /* Quick-add handled by dedicated listener below */

  /* ── Wishlist Drawer ── */
  const drawer = document.getElementById('wishlist-drawer');
  const body   = document.getElementById('wishlist-drawer-body');
  const overlay = document.getElementById('site-overlay');

  function openWLDrawer() {
    if (!drawer) return;
    renderWLDrawer();
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
  }

  function closeWLDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
  }

  function renderWLDrawer() {
    if (!body) return;
    const items = getWL();
    if (!items.length) {
      body.innerHTML = `
        <div class="wl-drawer__empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--stone-dark)" stroke-width="0.62" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 21C12 21 2.5 15.2 2.5 8.5C2.5 5.5 4.8 3.2 7.6 3.2C9.5 3.2 11.1 4.3 12 5.9C12.9 4.3 14.5 3.2 16.4 3.2C19.2 3.2 21.5 5.5 21.5 8.5C21.5 15.2 12 21 12 21Z"/>
          </svg>
          <p class="wl-drawer__empty-title">Your wishlist is empty</p>
          <p class="wl-drawer__empty-sub">Save hats you love by tapping the heart on any product</p>
          <a href="/collections/all" class="wl-drawer__shop-btn" onclick="closeWLDrawer()">Shop All Hats</a>
        </div>`;
      return;
    }
    body.innerHTML = `
      <div class="wl-drawer__grid">
        ${items.map(p => `
          <div class="wl-drawer__item" data-pid="${p.id}">
            <button class="wl-drawer__remove" data-pid="${p.id}" aria-label="Remove">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M1 1l8 8M9 1L1 9"/></svg>
            </button>
            <a href="${esc(p.url)}" class="wl-drawer__img-link">
              ${p.image ? `<img src="${p.image.replace(/(\.(?:jpg|jpeg|png|webp))/, '_320x$1')}" alt="${esc(p.title)}" loading="lazy">` : `<div class="wl-drawer__img-placeholder"></div>`}
            </a>
            <div class="wl-drawer__details">
              <a href="${esc(p.url)}" class="wl-drawer__name">${esc(p.title)}</a>
              <div class="wl-drawer__price">${fmt(p.price)}</div>
            </div>
            ${p.variant ? `<button class="wl-drawer__add" data-variant-id="${p.variant}" type="button">+ Bag</button>` : `<a href="${esc(p.url)}" class="wl-drawer__add wl-drawer__add--view">View</a>`}
          </div>`).join('')}
      </div>
      ${window.__hatsy_wishlist_url ? `<div class="wl-drawer__footer">
        <a href="${esc(window.__hatsy_wishlist_url)}" class="wl-drawer__view-all">View full wishlist</a>
      </div>` : ''}`;

    // Add to Bag buttons in drawer
    body.querySelectorAll('.wl-drawer__add[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', async function() {
        const vid = btn.dataset.variantId;
        if (!vid || btn.disabled || btn.dataset.available === 'false') return;
        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = '...';
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
          });
          if (r.ok) {
            btn.textContent = '✓ Added';
            // refresh cart count
            fetch('/cart.js').then(r => r.json()).then(c => {
              document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = c.item_count);
              document.querySelectorAll('[data-bag-label]').forEach(el => el.textContent = 'Bag (' + c.item_count + ')');
            });
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
          } else { btn.textContent = orig; btn.disabled = false; }
        } catch { btn.textContent = orig; btn.disabled = false; }
      });
    });

    // Remove buttons
    body.querySelectorAll('.wl-drawer__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const pid = parseInt(btn.dataset.pid);
        saveWL(getWL().filter(x => x.id !== pid));
        document.querySelectorAll('.js-wish[data-product-id="' + pid + '"]').forEach(applyHeart);
        updateBadge();
        notify();
        renderWLDrawer();
      });
    });
  }

  /* ── Wire nav button ── */
  const navBtn = document.getElementById('nav-wishlist-btn');
  navBtn && navBtn.addEventListener('click', openWLDrawer);

  /* ── Wire close ── */
  const closeBtn = document.getElementById('wishlist-close');
  closeBtn && closeBtn.addEventListener('click', closeWLDrawer);
  overlay && overlay.addEventListener('click', function() {
    closeWLDrawer();
    // also close cart/menu if open
  });

  /* ── Listen for updates ── */
  window.addEventListener('hatsy:wishlist-updated', () => {
    updateBadge();
    if (drawer && drawer.classList.contains('is-open')) renderWLDrawer();
  });

  updateBadge();

  // Expose for page template
  window.openWLDrawer = openWLDrawer;
  window.closeWLDrawer = closeWLDrawer;

})();

/* ════════════════════════════════════════════════
   COLLECTION — filter dropdowns + sort redirect
════════════════════════════════════════════════ */
(function initCollection() {
  // Filter toggles
  document.querySelectorAll('.filter-group__toggle').forEach(btn => {
    btn.addEventListener('click', function() {
      const group = btn.closest('.filter-group');
      const isOpen = group.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.filter-group.is-open').forEach(g => g.classList.remove('is-open'));
      if (!isOpen) group.classList.add('is-open');
    });
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.filter-group')) {
      document.querySelectorAll('.filter-group.is-open').forEach(g => g.classList.remove('is-open'));
    }
  });

  // Filter checkboxes → navigate
  document.querySelectorAll('.filter-checkbox').forEach(cb => {
    cb.addEventListener('change', function() {
      const form = document.createElement('form');
      form.method = 'GET';
      form.action = window.location.pathname;
      document.querySelectorAll('.filter-checkbox:checked').forEach(c => {
        const inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = c.name; inp.value = c.value;
        form.appendChild(inp);
      });
      document.body.appendChild(form);
      form.submit();
    });
  });

  // Sort select → navigate
  const sortSel = document.getElementById('sort-by');
  if (sortSel) {
    sortSel.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }
})();

/* ════════════════════════════════════════════════
   PRODUCT PAGE — gallery, variants, accordions, ATC
════════════════════════════════════════════════ */
(function initProductPage() {
  if (!document.querySelector('.pdp-wrap')) return;

  /* ── Mobile gallery swipe + dots + keyboard ── */
  (function() {
    var strip = document.getElementById('pdp-strip');
    if (!strip) return;
    var dots = Array.from(document.querySelectorAll('.pdp-gallery__dot'));
    var total = dots.length;
    if (total < 2) return;
    var current = 0;
    var ticking = false;

    function goTo(idx) {
      idx = Math.max(0, Math.min(total - 1, idx));
      current = idx;
      // Use scrollLeft directly — scroll-snap handles the smooth snap natively
      strip.scrollLeft = idx * strip.offsetWidth;
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    }

    // Sync dots on scroll — debounced via requestAnimationFrame
    strip.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var w = strip.offsetWidth;
        if (w) {
          var idx = Math.round(strip.scrollLeft / w);
          if (idx !== current) {
            current = idx;
            dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
          }
        }
        ticking = false;
      });
    }, { passive: true });

    // Dot clicks — jump directly, CSS snap handles alignment
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); });
    });

    // Keyboard arrows (strip has tabindex="0")
    strip.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
    });
  })();

  /* ── Variant switching ── */
  const variants  = window.__hatsy_variants || [];
  const variantEl = document.getElementById('product-variant-id');
  const priceEl   = document.getElementById('pdp-price');
  const atcBtn    = document.getElementById('product-atc');
  const wishBtn   = document.querySelector('.pdp-wish-btn');

  let selectedOptions = [];

  // Read initial selections
  document.querySelectorAll('.pdp-option').forEach(function(group) {
    const active = group.querySelector('.is-active');
    if (active) selectedOptions[parseInt(active.dataset.optionIndex)] = active.dataset.value;
  });

  function findVariant() {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function updateUI(variant) {
    if (!variant) return;
    if (variantEl) variantEl.value = variant.id;
    if (wishBtn) wishBtn.dataset.variant = variant.id;

    // Price
    if (priceEl) {
      const wasEl = priceEl.querySelector('.pdp-info__price--was');
      const nowEl = priceEl.querySelector('.pdp-info__price--now');
      if (nowEl) nowEl.textContent = formatMoney(variant.price);
      if (wasEl) {
        if (variant.compare_at_price > variant.price) {
          wasEl.textContent = formatMoney(variant.compare_at_price);
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }
    }

    // ATC
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available
        ? 'Add to Bag — ' + formatMoney(variant.price)
        : 'Sold Out';
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Option button clicks
  document.querySelectorAll('.pdp-option__btn, .pdp-swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const idx = parseInt(btn.dataset.optionIndex);
      const val = btn.dataset.value;
      selectedOptions[idx] = val;
      // Update active state in group
      btn.closest('.pdp-option__buttons, .pdp-option__swatches').querySelectorAll('button').forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.value === val);
      });
      // Update color label
      const label = btn.closest('.pdp-option').querySelector('.pdp-option__selected');
      if (label) label.textContent = val;
      // Find matching variant
      const match = findVariant();
      if (match) updateUI(match);
    });
  });

  // Init with first available variant
  const initVariant = findVariant();
  if (initVariant) updateUI(initVariant);

  /* ── Accordions ── */
  document.querySelectorAll('.pdp-accordion__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const acc = btn.closest('.pdp-accordion');
      const isOpen = acc.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.pdp-accordion.is-open').forEach(function(a) {
        a.classList.remove('is-open');
        a.querySelector('.pdp-accordion__toggle').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        acc.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── ATC form submit ── */
  const form = document.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;
      const vid = variantEl ? variantEl.value : null;
      if (!vid) return;
      const orig = atcBtn.textContent;
      atcBtn.classList.add('is-loading');
      atcBtn.textContent = 'Adding...';
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
        });
        if (r.ok) {
          atcBtn.textContent = '✓ Added to Bag';
          await refreshCart();
          openCart();
          setTimeout(function() {
            atcBtn.classList.remove('is-loading');
            atcBtn.textContent = orig;
          }, 2000);
        } else {
          atcBtn.classList.remove('is-loading');
          atcBtn.textContent = orig;
        }
      } catch {
        atcBtn.classList.remove('is-loading');
        atcBtn.textContent = orig;
      }
    });
  }

  /* ── Wishlist heart on PDP ── */
  if (wishBtn) {
    const WL_KEY = 'hatsy_wishlist';
    function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } }
    function isWished(id) { return getWL().some(function(x) { return x.id === id; }); }
    function applyWish() {
      const id = parseInt(wishBtn.dataset.productId);
      wishBtn.classList.toggle('is-wishlisted', isWished(id));
    }
    applyWish();
    window.addEventListener('hatsy:wishlist-updated', applyWish);
  }

})();

/* ════════════════════════════════════════════════
   PRODUCT PAGE — gallery, variants, ATC
════════════════════════════════════════════════ */
(function() {
  if (!document.querySelector('.pdp-wrap')) return;

  /* ── Gallery thumbnail switching ── */
  var activeImg = document.getElementById('pdp-active-img');
  document.querySelectorAll('.pdp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (activeImg) {
        activeImg.src = thumb.dataset.src;
        activeImg.alt = thumb.dataset.alt;
      }
      document.querySelectorAll('.pdp-gallery__thumb').forEach(function(t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* ── Variant switching ── */
  var variants   = window.__hatsy_variants || [];
  var variantEl  = document.getElementById('pdp-variant-id');
  var priceEl    = document.getElementById('pdp-price');
  var atcBtn     = document.getElementById('pdp-atc');
  var wishBtn    = document.querySelector('.pdp-gallery-wish');
  var selectedOpts = {};

  // Init selected options from active buttons
  document.querySelectorAll('.pdp-opt-btn.is-active, .pdp-swatch.is-active').forEach(function(btn) {
    selectedOpts[btn.dataset.oi] = btn.dataset.val;
  });

  function findVariant() {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOpts[i]; });
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateUI(v) {
    if (!v) return;
    if (variantEl) variantEl.value = v.id;
    if (wishBtn) wishBtn.dataset.variant = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? 'Add to Bag — ' + money(v.price) : 'Sold Out';
    }
  }

  document.querySelectorAll('.pdp-opt-btn, .pdp-swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var oi = btn.dataset.oi;
      selectedOpts[oi] = btn.dataset.val;
      // Update active in group
      var group = btn.closest('.pdp-option__btns, .pdp-swatches');
      if (group) group.querySelectorAll('button').forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.val === btn.dataset.val);
      });
      // Update color label
      var label = btn.closest('.pdp-option') && btn.closest('.pdp-option').querySelector('.pdp-option__val');
      if (label && label.dataset.oi === oi) label.textContent = btn.dataset.val;
      // Update gallery if variant has image
      var match = findVariant();
      if (match) {
        updateUI(match);
        if (match.featured_image && activeImg) {
          var src = match.featured_image.src;
          // Shopify image URL - add width param
          activeImg.src = src.replace(/(\.(jpg|jpeg|png|webp))/, '_1400x$1');
        }
      }
    });
  });

  // Init
  var initV = findVariant();
  if (initV) updateUI(initV);

  /* ── ATC ── */
  var form = document.querySelector('[data-product-form], .pdp-wrap form');
  if (form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;
      var vid = variantEl ? parseInt(variantEl.value) : null;
      if (!vid) return;
      var orig = atcBtn.textContent;
      atcBtn.dataset.busy = '1';   /* adding, not sold out: the notify-me script ignores this */
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';
      try {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        });
        if (r.ok) {
          atcBtn.textContent = '✓ Added to Bag';
          if (typeof refreshCart === 'function') await refreshCart();
          if (typeof openCart === 'function') openCart();
          setTimeout(function() { atcBtn.textContent = orig; atcBtn.disabled = false; delete atcBtn.dataset.busy; }, 2000);
        } else { atcBtn.textContent = orig; atcBtn.disabled = false; delete atcBtn.dataset.busy; }
      } catch(err) { atcBtn.textContent = orig; atcBtn.disabled = false; delete atcBtn.dataset.busy; }
    });
  }

  /* ── Wishlist heart on PDP ── */
  if (wishBtn) {
    var WL = 'hatsy_wishlist';
    function getWL() { try { return JSON.parse(localStorage.getItem(WL)||'{"items":[],"ts":0}'); } catch { return {items:[],ts:0}; } }
    function isWished(id) { return (getWL().items||[]).some(function(x){return x.id===id;}); }
    function applyWish() { wishBtn.classList.toggle('is-wishlisted', isWished(parseInt(wishBtn.dataset.productId))); }
    applyWish();
    window.addEventListener('hatsy:wishlist-updated', applyWish);
  }

})();

/* ════════════════════════════════════════════════
   PDP STICKY ATC BAR
════════════════════════════════════════════════ */
(function() {
  var stickyBar = document.getElementById('pdp-sticky-bar');
  var atcBtn = document.getElementById('pdp-atc');
  var stickyBtn = document.getElementById('pdp-sticky-atc');
  if (!stickyBar || !atcBtn) return;

  // Only show the bar after the main ATC has been scrolled PAST —
  // i.e. it must have been visible in the viewport at least once first,
  // then scrolled out below the top. Never show on initial page load.
  var hasBeenVisible = false;
  var hasBeenScrolledPast = false;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // ATC is now visible — mark it as seen, hide the bar
        hasBeenVisible = true;
        stickyBar.classList.remove('is-visible');
      } else if (hasBeenVisible) {
        // ATC was visible before and now isn't — user scrolled past it
        // Only show bar if ATC is above the viewport (scrolled past downward)
        var rect = atcBtn.getBoundingClientRect();
        if (rect.top < 0) {
          hasBeenScrolledPast = true;
          stickyBar.classList.add('is-visible');
        }
        // If ATC is below viewport (page just loaded, bar offscreen) — don't show
      }
    });
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(atcBtn);
  /* sold-out items show "Notify me" instead of the add button: track whichever one is on screen */
  var notifyBtn = document.getElementById('pdp-notify');
  if (notifyBtn) {
    var nObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (notifyBtn.hidden) return;
        if (entry.isIntersecting) { hasBeenVisible = true; stickyBar.classList.remove('is-visible'); }
        else if (hasBeenVisible && notifyBtn.getBoundingClientRect().top < 0) { hasBeenScrolledPast = true; stickyBar.classList.add('is-visible'); }
      });
    }, { threshold: 0, rootMargin: '0px' });
    nObserver.observe(notifyBtn);
  }

  // Sticky btn triggers same form submit
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainForm = document.querySelector('.pdp-wrap form');
      if (mainForm) mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
})();

// ── Drawer search toggle ──
(function() {
  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('#drawer-search-toggle');
    var closeBtn  = e.target.closest('#drawer-search-close');
    var form      = document.getElementById('drawer-search-form');
    var input     = document.getElementById('drawer-search-input');
    var btn       = document.getElementById('drawer-search-toggle');
    if (!form) return;

    if (toggleBtn) {
      var isOpen = form.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
      if (isOpen) { setTimeout(function(){ if(input) input.focus(); }, 320); }
    }
    if (closeBtn) {
      form.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });
})();

// ── PDP Component Accordion ──
(function() {
  function initAccordions() {
    document.querySelectorAll('.pdpe-acc__trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.pdpe-acc__item');
        var body = item.querySelector('.pdpe-acc__body');
        var isOpen = item.classList.contains('is-open');

        // Close all others
        document.querySelectorAll('.pdpe-acc__item.is-open').forEach(function(open) {
          open.classList.remove('is-open');
          open.querySelector('.pdpe-acc__trigger').setAttribute('aria-expanded', 'false');
          open.querySelector('.pdpe-acc__body').style.maxHeight = '0';
        });

        // Toggle this one
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();

/* ══════════════════════════════════════
   JOURNAL VIDEO: autoplay muted + sound toggle
══════════════════════════════════════ */
(function () {
  function frameOf(btn) { return btn.closest('[data-jnl-video]'); }

  function setState(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
    btn.classList.toggle('is-on', on);
  }

  function muteAllExcept(current) {
    document.querySelectorAll('[data-jnl-video]').forEach(function (f) {
      if (f === current) return;
      var b = f.querySelector('[data-jnl-sound]');
      if (b && b.classList.contains('is-on')) toggle(b, false);
    });
  }

  function toggle(btn, force) {
    var frame = frameOf(btn);
    if (!frame) return;
    var on = typeof force === 'boolean' ? force : !btn.classList.contains('is-on');
    var vid = frame.querySelector('video');
    var ifr = frame.querySelector('iframe');

    if (vid) {
      vid.muted = !on;
      if (on) { vid.volume = 1; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    } else if (ifr) {
      var prov = ifr.getAttribute('data-jnl-provider');
      try {
        if (prov === 'youtube') {
          ifr.contentWindow.postMessage(JSON.stringify({
            event: 'command', func: on ? 'unMute' : 'mute', args: []
          }), 'https://www.youtube.com');
          if (on) ifr.contentWindow.postMessage(JSON.stringify({
            event: 'command', func: 'setVolume', args: [100]
          }), 'https://www.youtube.com');
        } else if (prov === 'vimeo') {
          ifr.contentWindow.postMessage(JSON.stringify({
            method: 'setVolume', value: on ? 1 : 0
          }), 'https://player.vimeo.com');
        }
      } catch (e) {}
    }
    setState(btn, on);
    if (on) muteAllExcept(frame);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jnl-sound]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  /* If the phone blocks autoplay (e.g. iPhone Low Power Mode): show a play button on
     each video and start the on-screen videos on the visitor's first tap. */
  var gestureArmed = false;
  function markBlocked(v) {
    var f = v.closest('[data-jnl-video]');
    if (!f) return;
    f.classList.add('jnl-video--blocked');
    if (!f.querySelector('.jnl-video__play')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jnl-video__play';
      b.setAttribute('aria-label', 'Play video');
      b.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.5 5.5v13l11-6.5z"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = true; tryPlay(v); });
      f.appendChild(b);
    }
    if (!gestureArmed) {
      gestureArmed = true;
      var kick = function () {
        gestureArmed = false;
        document.removeEventListener('touchstart', kick, true);
        document.removeEventListener('click', kick, true);
        document.querySelectorAll('[data-jnl-video] video').forEach(function (bv) {
          var r = bv.getBoundingClientRect();
          if (bv.paused && r.bottom > 0 && r.top < window.innerHeight) tryPlay(bv);
        });
      };
      document.addEventListener('touchstart', kick, { capture: true, passive: true });
      document.addEventListener('click', kick, true);
    }
  }
  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') markBlocked(v); });
  }
  function initVideos() {
    document.querySelectorAll('[data-jnl-video] video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.addEventListener('playing', function () {
        var f = v.closest('[data-jnl-video]');
        if (f) f.classList.remove('jnl-video--blocked');
      });
      tryPlay(v);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          tryPlay(v);
          setTimeout(function () {
            var r = v.getBoundingClientRect();
            if (v.paused && r.bottom > 0 && r.top < window.innerHeight) markBlocked(v);
          }, 1500);
        } else {
          v.pause();
          var b = v.closest('[data-jnl-video]');
          b = b && b.querySelector('[data-jnl-sound]');
          if (b && b.classList.contains('is-on')) toggle(b, false);
        }
      });
    }, { threshold: 0.25 });
    document.addEventListener('DOMContentLoaded', function () {
      initVideos();
      document.querySelectorAll('[data-jnl-video] video').forEach(function (v) { io.observe(v); });
    });
  } else {
    document.addEventListener('DOMContentLoaded', initVideos);
  }
})();
